export default {
  setMitigationHabitats (state, mitigationHabitats) {
    state.mitigationHabitats = mitigationHabitats
  },

  setMitigationHabitatsLoading (state, loading) {
    state.loading = loading
  },

  addMitigationHabitat (state, mitigationHabitat) {
    state.mitigationHabitats.push(mitigationHabitat)
  },

  removeMitigationHabitat (state, mitigationHabitatId) {
    state.mitigationHabitats = state.mitigationHabitats.filter(h => h.mitigationHabitatId !== mitigationHabitatId)
  },

  updateMitigationHabitat (state, mitigationHabitat) {
    const index = state.mitigationHabitats.findIndex(h => h.mitigationHabitatId === mitigationHabitat.mitigationHabitatId)
    if (index !== -1) {
      Object.assign(state.mitigationHabitats[index], mitigationHabitat)
    }
  }
}
